import { useState, memo } from "react";

import "../Style/Filter.css"
import ToggleSwitch from './ToggleSwitch';
import { ReactComponent as SearchIconSvg } from "../SVG/search-icon.svg"
import TogglePassengerCount from "./TogglePassengerCount";

const Filter = (props) => {

    // const traintype_arr = [
    //     { value: "all", name: "All" },
    //     { value: "c", name: "C-train" },
    //     { value: "q", name: "Q-train" },
    //     { value: "m", name: "M-train" },
    //     { value: "k", name: "K-train" },
    //     { value: "caf", name: "Caf-train" },

    // ];

    const [traintypeArr, setTrainTypeArr] = useState(props.traintypes);

    // const station_arr = [
    //     { value: "all", name: "All Stations", selected: true },
    //     { value: 1, name: "NOP" },
    //     { value: 2, name: "POA" },
    //     { value: 3, name: "TIK" },
    //     { value: 4, name: "LHP" },
    // ];

    const [stationArr, setStationArr] = useState(
        [{ value: "all", name: "All Stations", selected: true }].concat(props.stations.map((item, index) => ({ value: index, name: item })))
    );

    const handleClickReloadBtn = () => {
        console.log("Clicked Reload");
        props.triggerReloadFunction();
    }

    const handleInputKeyword = (e) => {
        console.log("Inputted Keyword: ", e.target.value);
        props.triggerKeywordFilterFunction(e.target.value);
    }

    const handleSelectTrainType = (e) => {
        // console.log("Selected TrainType: ", e.target.value);
        // console.log("Selected TrainType: ", e.target.selectedOptions[0].text);
        props.triggerTraintypeFilterFunction(e.target.selectedOptions[0].text);
    }

    const handleToggleHideNotInServiceTrain = (isToggled) => {
        console.log("Toggled HideNotInServiceTrain", isToggled);
    }

    const handleToggleHideUpDirection = (isToggled) => {
        console.log("Toggled HideUpDirection", isToggled);
        props.triggerShowUpDirectionFilterFunction(isToggled);
    }

    const handleToggleHideDownDirection = (isToggled) => {
        console.log("Toggled HideDownDirection", isToggled);
        props.triggerShowDownDirectionFilterFunction(isToggled);
    }

    const handleSelectStation = (e) => {
        const options = [...e.target.selectedOptions];
        const values = options.map(option => option.value);
        console.log("Selected Station: ", values);
        props.triggerStationFilterFunction(values);
    }

    // useEffect(() => {
    //     //

    // }, [])

    return (
        <>
            {console.log("Filter Component is Rerendered")}
            <div className="filter-wrapper">
                <div className="filter-item-1">
                    <select name="train-type" id="train-type" className="cursor-pointer border-2  rounded-md" onChange={handleSelectTrainType}>
                        {
                            traintypeArr.map((item, index) => (<option key={index} value={item.value}>{item.name}</option>))
                        }
                    </select>
                    <div className="filter-item-3">
                        <select name="stations" id="stations" className="station-filter cursor-pointer border-2  rounded-md" defaultValue={'All Stations'} /* multiple={true} */ onChange={handleSelectStation} >

                            {
                                stationArr.map((item, index) => (<option key={index} value={item.name} >{item.name}</option>))
                            }

                        </select>
                    </div>

                    <div className="searchIcon">
                        <SearchIconSvg></SearchIconSvg>
                    </div>
                    <input type="text" className="keyword-input" onChange={handleInputKeyword} placeholder="Train ID or TD" />

                    <button className="reload-btn" onClick={handleClickReloadBtn}>Reload</button>
                </div>
                <div className="filter-item-2">
                    {/* <div>
                        <input type="checkbox" /> 
                        <label> &nbsp; Hide Not in Service Trains</label>
                    </div>
                    <div>
                        <input type="checkbox" />
                        <label> &nbsp; Show Up Direction</label>
                    </div>
                    <div>
                        <input type="checkbox" /> 
                        <label> &nbsp; Show Down Direction</label>
                    </div> */}
                    <div className="left">
                        <ToggleSwitch content="Hide Not in Service Trains" togglefunction={handleToggleHideNotInServiceTrain} defaultChecked={true} disabled={true} />
                        <ToggleSwitch content="Show Up Direction" togglefunction={handleToggleHideUpDirection} defaultChecked={true} />
                        <ToggleSwitch content="Show Down Direction" togglefunction={handleToggleHideDownDirection} defaultChecked={true} />
                    </div>

                    <div className="right">
                        <TogglePassengerCount content="Show Passenger Count"y></TogglePassengerCount>
                    </div>

                </div>


            </div>

        </>
    );
}

const IsEqual = (oldProps, newProps) => {
    // console.log(oldProps);
    // console.log(newProps);
    return true;
};

export default memo(Filter, IsEqual);